"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agnosine": {
    "24dae64f": [{
      "hkey": "1019097c",
      "slug": "agnosine",
      "name": "Agnosine",
      "primary": true,
      "skipSearch": false
    }],
    "renzana": [{
      "hkey": "1019097c",
      "slug": "agnosine",
      "name": "Agnosine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1d26a397": [{
      "hkey": "1019097c",
      "slug": "agnosine",
      "name": "Agnosine",
      "primary": true,
      "skipSearch": false
    }],
    "trebbio": [{
      "hkey": "1019097c",
      "slug": "agnosine",
      "name": "Agnosine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;